var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseTemplate } from './base-template';
import * as Enumerable from 'linq';
import { FormatterHelper } from '../../../utilities/format-helper';
import { NotificationType } from '../../../services/basics/notification-client.service';
import { Client } from '../../../views/app/client/client';
import { RouterConstants } from '../../../configuration/router.constants';
import { DrawDateHelper } from '../../../models/modules/draw-date-helper';
import { CartCurrencyValueConverter } from '../../../converters/currency-jackpot-converter';
var BaseCart = /** @class */ (function (_super) {
    __extends(BaseCart, _super);
    function BaseCart(router, gamePlayerTicketClientService, i18N, eventAggregator, dialogClientService, tokenClient, notificationClientService, lotteryClientService, hotLotteryClientService, navigationClientService) {
        var _this = _super.call(this, router, i18N, lotteryClientService, dialogClientService, tokenClient) || this;
        _this.gamePlayerTicketClientService = gamePlayerTicketClientService;
        _this.eventAggregator = eventAggregator;
        _this.notificationClientService = notificationClientService;
        _this.lotteryClientService = lotteryClientService;
        _this.hotLotteryClientService = hotLotteryClientService;
        _this.navigationClientService = navigationClientService;
        _this.items = [];
        // this is used for ui only
        _this.isFirstTime = true;
        _this.hideClearfix = true;
        _this.loadingLotteries = true;
        _this.hotLotteries = [];
        _this.tokenClient.getBalance();
        _this.defaultUserCurrencySymbol = tokenClient.getUserCurrency().symbol;
        return _this;
    }
    BaseCart.prototype.activate = function (params) {
        var _this = this;
        if (params)
            this.lotteryId = params.lotteryId;
        if (this.tokenClient.isAgent())
            this.router.navigateToRoute(RouterConstants.RouteNames.Lobby);
        var promise = _super.prototype.activate.call(this, params);
        this.loadCart();
        this.hotLotteryClientService.getHotLotteries().then(function (x) {
            _this.hotLotteries = x;
        }, function (x) {
            _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
        });
        return promise;
    };
    BaseCart.prototype.loadCart = function () {
        var _this = this;
        // here we need to scroll top #19327
        this.sendHeightToClient(this.lastKnownHeight + "px", true);
        setTimeout(function () {
            _this.hideClearfix = true;
        }, 800);
        this.gamePlayerTicketClientService.getCart(this.lotteryId).then(function (x) {
            _this.items = x.cartItems;
            _this.loadingLotteries = false;
            //start interval checks for draw date
            _this.disposeIntervalChecker();
            _this._intervalDrawDateChecker = setInterval(function () {
                _this.items.forEach(function (cartItem) {
                    var drawDate = new Date(cartItem.closingDateTime);
                    if (new Date() > drawDate && cartItem.closingDateTime) {
                        var calculatedDate = DrawDateHelper.calculateNextDrawDate(cartItem.isCustom, 2, false, cartItem.sunday, cartItem.monday, cartItem.tuesday, cartItem.wednesday, cartItem.thursday, cartItem.friday, cartItem.saturday, drawDate, cartItem.drawTime);
                        var drawTimeDate = new Date(cartItem.closingDateTime);
                        calculatedDate.setHours(drawTimeDate.getHours());
                        calculatedDate.setMinutes(drawTimeDate.getMinutes());
                        cartItem.drawDate = calculatedDate;
                    }
                });
            }, 10000);
        }, function (x) {
            _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
        });
    };
    BaseCart.prototype.detached = function () {
        _super.prototype.detached.call(this);
        this.disposeIntervalChecker();
    };
    BaseCart.prototype.disposeIntervalChecker = function () {
        if (this._intervalDrawDateChecker) {
            this._intervalDrawDateChecker = null;
        }
    };
    BaseCart.prototype.getPrize = function (lottery) {
        if (lottery) {
            return FormatterHelper.getformattedValue(lottery.totalJackpot, navigator.language, 2);
        }
        return '';
    };
    Object.defineProperty(BaseCart.prototype, "paidItems", {
        get: function () {
            return this.items.filter(function (x) { return !x.isFreeTicket; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCart.prototype, "freeItems", {
        get: function () {
            return this.items.filter(function (x) { return x.isFreeTicket; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCart.prototype, "freeTicketSavings", {
        get: function () {
            return Enumerable.from(this.freeItems).sum(function (x) { return (x.freeTicketFaceValue || 0) * (x.lines || 1); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCart.prototype, "subtotalPrice", {
        get: function () {
            return Enumerable.from(this.items).sum(function (x) { return Number(x.totalPrice || 0); });
        },
        enumerable: false,
        configurable: true
    });
    BaseCart.prototype.getFreeItemSavings = function (item) {
        return (item.freeTicketFaceValue || 0) * (item.lines || 1);
    };
    BaseCart.prototype.getFreeItemsForLottery = function (item) {
        return this.freeItems.filter(function (x) { return x.cartGuid === item.cartGuid; });
    };
    BaseCart.prototype.getDisplayLines = function (item) {
        return item.lines;
    };
    BaseCart.prototype.getPaidItemDisplayTotal = function (item) {
        var freeItems = this.getFreeItemsForLottery(item);
        var freePaidPortion = Enumerable.from(freeItems).sum(function (x) {
            return Number(x.totalPrice || 0) - (x.freeTicketFaceValue || 0) * (x.lines || 1);
        });
        return Number(item.totalPrice || 0) + freePaidPortion;
    };
    BaseCart.prototype.getFreeItemPaidDraws = function (freeItem) {
        return (freeItem.draws || 1) - 1;
    };
    BaseCart.prototype.getFreeItemInfoSuffix = function (item) {
        var _this = this;
        return this.getFreeItemsForLottery(item)
            .filter(function (fi) { return (fi.draws || 1) > 1; })
            .map(function (fi) { return " + ".concat(fi.lines, " ").concat(_this.i18n.tr('lines'), " | ").concat((fi.draws || 1) - 1, " ").concat(_this.i18n.tr('draws')); })
            .join('');
    };
    Object.defineProperty(BaseCart.prototype, "totalPrice", {
        get: function () {
            var _this = this;
            var paid = Enumerable.from(this.paidItems).sum(function (x) {
                var converter = new CartCurrencyValueConverter(_this.tokenClient);
                return Number(converter.toView(x, false, true));
            });
            var freePaidPortion = Enumerable.from(this.freeItems).sum(function (x) {
                if (!_this.paidItems.some(function (p) { return p.lotteryId === x.lotteryId; }))
                    return 0;
                return Number(x.totalPrice || 0) - (x.freeTicketFaceValue || 0) * (x.lines || 1);
            });
            return paid + freePaidPortion;
        },
        enumerable: false,
        configurable: true
    });
    BaseCart.prototype.getDrawDate = function (lottery) {
        if (lottery) {
            return lottery.drawDate;
        }
        return new Date();
    };
    BaseCart.prototype.edit = function (item) {
        if (item.bundleId) {
            this.router.navigateToRoute(RouterConstants.RouteNames.Bundle, {
                bundleId: item.bundleId,
                cartGuid: item.cartGuid,
                isFromCart: true,
                draws: item.draws,
                key: this.getBundleKey(item.lotteryName),
                canRevert: true,
                bundleGuid: item.bundleGuid
            });
        }
        else if (item.syndicateId) {
            this.router.navigateToRoute(RouterConstants.RouteNames.Syndicate, {
                numberOfShares: item.syndicateNumberOfShares * item.numberOfTips,
                syndicateId: item.syndicateId,
                brandLotteryId: item.brandLotteryId,
                cartGuid: item.cartGuid,
                isFromCart: true,
                draws: item.draws,
                key: this.getBundleKey(item.lotteryName),
                canRevert: true
            });
        }
        else {
            this.router.navigateToRoute(RouterConstants.RouteNames.Lottery, {
                lotteryId: item.lotteryId,
                brandLotteryId: item.brandLotteryId,
                cartGuid: item.cartGuid,
                isFromCart: true,
                draws: item.draws,
                key: this.getLotteryKey(item.lotteryName),
                canRevert: true
            });
        }
    };
    BaseCart.prototype.remove = function (item) {
        var _this = this;
        this.gamePlayerTicketClientService.removeCartItem(item.cartGuid, item.brandLotteryId).then(function (x) {
            var index = _this.items.indexOf(item);
            _this.items.splice(index, 1);
            if (!item.isFreeTicket) {
                var pairedFreeItem = _this.freeItems.find(function (f) { return f.cartGuid === item.cartGuid; });
                if (pairedFreeItem) {
                    var freeIndex = _this.items.indexOf(pairedFreeItem);
                    if (freeIndex >= 0)
                        _this.items.splice(freeIndex, 1);
                }
            }
            _this.eventAggregator.publish(Client.UpdateCartCount);
        });
    };
    BaseCart.prototype.openLines = function (item) {
        item.isLinesOpen = !item.isLinesOpen;
    };
    BaseCart.prototype.getRemainingBonus = function (drawnBonusNumbers, ticket) {
        return drawnBonusNumbers - Enumerable.from(ticket.bonus).count();
    };
    BaseCart.prototype.getRemainingMain = function (drawnNumbers, ticket) {
        return drawnNumbers - Enumerable.from(ticket.main).count();
    };
    BaseCart.prototype.getCreateTicketRequest = function (cartItem, ticket, draws) {
        if (cartItem.bundleGuid) {
            var ticketDraw = cartItem.cartBundleBrandLotteries.find(function (x) { return x.brandLotteryId == ticket.brandLotteryId; });
            draws = (ticketDraw ? ticketDraw.numberOfDraws : cartItem.draws);
        }
        return {
            bundleGuid: cartItem.bundleGuid,
            cartGuid: cartItem.cartGuid,
            sequenceNumber: cartItem.lineNumbers.indexOf(ticket),
            bonusPicks: ticket.bonus.join(","),
            mainPicks: ticket.main.join(","),
            ticketGuid: ticket.guid,
            ticketId: ticket.ticketId,
            brandLotteryId: ticket.brandLotteryId,
            bundleId: cartItem.bundleId,
            syndicateId: cartItem.syndicateId,
            numberOfShares: cartItem.syndicateNumberOfShares * cartItem.numberOfTips,
            draws: draws,
            recordedSessionId: Client.RECORDING_SESSION_ID,
            isFromCart: true,
            subscriptionMonths: cartItem.subscriptionInMonths,
            isFreeTicket: cartItem.isFreeTicket || false,
            pricingDraws: cartItem.pricingDraws
        };
    };
    BaseCart.prototype.purchaseTickets = function () {
        var _this = this;
        if (this.isBuyingTickets)
            return;
        this.isUnauthorized = false;
        this.isBuyingTickets = true;
        var tickets = Enumerable.from(this.items).selectMany(function (x) {
            return Enumerable.from(x.lineNumbers)
                .select(function (ticket) { return _this.getCreateTicketRequest(x, ticket, x.draws); }).toArray();
        }).toArray();
        if (tickets.length <= 0) {
            this.isBuyingTickets = false;
            this.notificationClientService.show(this.i18n.tr("no-tickets-to-purchase"), "", NotificationType.Warning);
        }
        else {
            if (!this.tokenClient.isAuthenticated) {
                // when user logs in user must be redirected to my purchases
                this.navigationClientService.cache(RouterConstants.RouteNames.Purchases, { lotteryId: this.lotteryId });
            }
            this.gamePlayerTicketClientService.purchaseTickets({
                tickets: tickets,
                purchasedFromCart: true
            }).then(function (x) {
                _this.isBuyingTickets = false;
                _this.items = [];
                _this.navigateToLobby();
                _this.eventAggregator.publish(Client.UpdateCartCount);
                _this.notificationClientService.show(_this.i18n.tr("tickets-confirmed-notification-title"), _this.i18n.tr("tickets-confirmed-notification-message"), NotificationType.Success);
            }, function (x) {
                _this.isUnauthorized = x && x.statusCode == 401 && !_this.tokenClient.user.enableLoginDialog;
                if (x && !_this.isUnauthorized)
                    _this.notificationClientService.show(_this.i18n.tr("notification-error-title"), _this.i18n.tr(x.response), NotificationType.Error);
                _this.isBuyingTickets = false;
            });
        }
    };
    BaseCart.prototype.navigateToLotteryAndSubscribe = function (item) {
        var key = this.getLotteryKey(item.lotteryName);
        this.router.navigateToRoute(RouterConstants.RouteNames.Lottery, {
            lotteryId: item.lotteryId,
            key: key,
            brandLotteryId: item.brandLotteryId,
            isSubscribe: true,
            draws: item.draws
        });
        window.dataLayer.push({
            "openedLotteryId": item.lotteryId,
            "openedLotteryName": item.lotteryName,
            "event": "navigate_lottery"
        });
    };
    BaseCart.prototype.navigateToLottery = function (item) {
        var key = this.getLotteryKey(item.lotteryName);
        this.router.navigateToRoute(RouterConstants.RouteNames.Lottery, {
            lotteryId: item.lotteryId,
            key: key,
            brandLotteryId: item.brandLotteryId,
            draws: item.draws
        });
        window.dataLayer.push({
            "openedLotteryId": item.lotteryId,
            "openedLotteryName": item.lotteryName,
            "event": "navigate_lottery"
        });
    };
    BaseCart.prototype.chooseNumbers = function (cartItem, line) {
        if (cartItem.bundleId) {
            var templateName = this.tokenClient.user.templateName.toLowerCase();
            try {
                require("./" + templateName + "/dialogs/choose-numbers-dialog");
            }
            catch (_a) {
                console.log("Cannot load choose numbers dialog for template " + templateName);
            }
            var lottery = Enumerable.from(this.lotteries).firstOrDefault(function (x) { return x.brandLotteryId == line.brandLotteryId; });
            this.dialogClient.show("app/styles/client/templates/" + templateName + "/dialogs/choose-numbers-dialog", {
                ticket: line,
                lottery: lottery,
                bundleId: cartItem.bundleId,
                bundleKey: this.getBundleKey(cartItem.lotteryName),
                isFromCart: true,
                cartGuid: cartItem.cartGuid
            }, true, true);
        }
        else {
            this.cartItemInEdit = cartItem;
            this.dialogLottery = Enumerable.from(this.lotteries).firstOrDefault(function (x) { return x.brandLotteryId == cartItem.brandLotteryId; });
            this.dialogKey = this.getLotteryKey(cartItem.lotteryName);
            this.isFirstTime = false;
            this.ticketInEdit = {
                bonus: line.bonus,
                main: line.main,
                guid: line.guid,
                ticketId: line.ticketId
            };
            this.hideClearfix = false;
            this.setChooseTicketHeight();
        }
    };
    BaseCart.prototype.setChooseTicketHeight = function () {
        var _this = this;
        setTimeout(function () {
            var navHeight = $(".common-navigation-menu")[0] ? $(".common-navigation-menu")[0].clientHeight : 0;
            var chooseTicketHeight = $("choose-ticket").height() + navHeight;
            _this.sendHeightToClient(chooseTicketHeight + "px", true);
        }, 100);
    };
    BaseCart.prototype.closeEditDialog = function () {
        var _this = this;
        this.ticketInEdit = null;
        this.sendHeightToClient(this.lastKnownHeight + "px", true);
        setTimeout(function () {
            _this.hideClearfix = true;
        }, 800);
    };
    return BaseCart;
}(BaseTemplate));
export { BaseCart };
